// "use strict";
/* global setTimeout, clearTimeout */

// Uses concepts of Closures and lexical scoping
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Closures

// function Typeahead(input, getOptions, selectOption) { // eslint-disable-line
//   var self = { input: input }
//   var menuOptions = []
//   var menuIndex = -1
//   var _req

// Add Methods
// function handleKeyDown(event) {
//   var maxIndex = menuOptions.length - 1
//   if (maxIndex < 0 || menuIndex < 0) return event // Do not interfere if no menu
//   switch (event.which) {
//     case 40: // down
//       event.preventDefault()
//       menuIndex++
//       if (menuIndex > maxIndex) { menuIndex = maxIndex }
//       updateActiveInMenu()
//       break
//     case 38: // up
//       event.preventDefault()
//       menuIndex--
//       if (menuIndex < 0) { menuIndex = maxIndex }
//       updateActiveInMenu()
//       break
//     case 9: // tab
//     case 13: // enter
//       event.preventDefault()
//       handleOptionSelect(menuIndex)
//       break
//     case 27: // esc
//       event.preventDefault()
//       resetMenu()
//       break
//   }
// }

function handleInput(event) {
  var onGettingOptions = function (options) {
    // parse to json if string
    if (typeof options === 'string') { options = JSON.parse(options) }
    // Replace options in menu
    menuOptions = options
    menuIndex = 0
    var newMenu = getNewMenu()
    var parent = self.menu.parentNode
    parent.replaceChild(newMenu, self.menu)
    self.menu = newMenu
  }
  if (_req) { _req.abort() }
  _req = getOptions(event.target.value, onGettingOptions)
}

function handleOptionSelect(index) {
  menuIndex = index
  updateActiveInMenu()
  selectOption(menuOptions, menuIndex)
  resetMenu()
}

// function handleBlur(event) {
//   setTimeout(function () {
//     resetMenu()
//   }, 200)
// }

function updateActiveInMenu() {
  var lis = self.menu.querySelectorAll('li')
  for (var i = 0; i < lis.length; i++) {
    lis[i].className = menuIndex === i ? 'active' : ''
  }
}

function getNewMenu() {
  var menu = document.createElement('ul')
  menu.classList.add('dropdown-content', 'visible')
  for (var i = 0; i < menuOptions.length; i++) {
    (function () {
      var index = i
      var li = document.createElement('li')
      li.textContent = menuOptions[i].name
      if (index === menuIndex) { li.className = 'active' }
      li.addEventListener('mousedown', function () { handleOptionSelect(index) })
      menu.appendChild(li)
    })()
  }
  return menu
}

function resetMenu() {
  menuIndex = -1
  menuOptions = []
  self.menu.classList.remove('visible')
}

//   // make the parent position default relative to set dropdown position
//   var parent = input.parentNode
//   // Add Menu
//   input.style.marginBottom = 0
//   self.menu = getNewMenu()
//   parent.appendChild(self.menu)
//   // hide menu is starting
//   resetMenu()

//   // Add listeners
//   input.addEventListener('keydown', handleKeyDown)
//   input.addEventListener('input', handleInput)
//   input.addEventListener('blur', handleBlur)
//   return self
// }

// Typeahead Utility Functions

function getTillCursor(textarea) {
  var fullVal = textarea.value
  var cursorPos = textarea.selectionStart
  var tillCursor = fullVal.substring(0, cursorPos)
  return tillCursor
}

function getLastWordBeforeCursor(textarea) {
  var tillCursor = getTillCursor(textarea)
  if (tillCursor.toLowerCase().endsWith(' and')) {
    return tillCursor.substring(tillCursor.length - 3)
  }
  if (tillCursor.toLowerCase().endsWith(' or')) {
    return tillCursor.substring(tillCursor.length - 2)
  }
  var pattern = /\sand\s|\sor\s|[^a-z0-9 ]|\n/gi
  // var pattern = /\sand\s|\sor\s|[^a-zA-Z0-9\s\w\(\){}[\]!@#$%^&*_;'",.?/:`~|\\\-]+|\n/gi;
  // var pattern = /\sand\s|\sor\s|[^a-zA-Z0-9\s\w\(\){}[\]!@#$%^&_ ;'",.?/:`~|\\\-]+|\n/gi;
  var parts = tillCursor.split(pattern)
  if (parts.length) return parts[parts.length - 1].trim()
  return ''
}

function insertWord(textarea, text, appendOnly) {
  // Inserts the given word in the query-builder at cursor position
  var fullVal = textarea.value
  var cursorPos = textarea.selectionStart
  var tillCursor = fullVal.substring(0, cursorPos)
  var lastWord = getLastWordBeforeCursor(textarea)
  var insertPos = tillCursor.lastIndexOf(lastWord)
  if (appendOnly) insertPos = cursorPos
  if (insertPos === -1) return
  var before = fullVal.substring(0, insertPos)
  var after = fullVal.substring(cursorPos)
  var newVal = before + text + after
  var newPos = newVal.length - after.length
  textarea.value = newVal
  textarea.selectionStart = newPos
  textarea.selectionEnd = newPos
}

function handleKeyDown(event) {
  var index = this.state.index;
  var opLen = this.getOptions().length;
  switch (event.which) {
    case 40:  //down
      event.preventDefault();
      this.setState({ index: Math.min(index + 1, opLen - 1) });
      break;
    case 38:  //up
      event.preventDefault();
      this.setState({
        index: index < 0 ? opLen - 1 : Math.max(0, index - 1)
      });
      break;
    case 9:   // tab
    case 13:  // enter
      if (index < 0 || opLen < 1) return;
      event.preventDefault();
      this.handleSelect(index);
      break;
    case 27:  // esc
      event.preventDefault();
      this.hideMenu();
      break;
    default:
  }
}

function handleBlur() {
  this.blurTimer = setTimeout(
    () => this.hideMenu()
    , 200);
}

function hideMenu() {
  this.setState({
    index: -1,
    hideMenu: true
  });
}

function handleUnmount() {
  clearTimeout(this.blurTimer);
}

function getConditionEnum(conditionSymbol) {
  const conditionMap = {
    '<': 'LESS_THAN',
    '>': 'GREATER_THAN',
    '<=': 'LESS_THAN_EQUAL',
    '>=': 'GREATER_THAN_EQUAL',
    '=': 'EQUALS',
    '!=': 'NOT_EQUALS',
  };

  return conditionMap[conditionSymbol] || null;
};

function removeOperatorsAndNumbers(inputString) {
  const regex = /(?:<|>|<=|>=)\s*\d+(\.\d+)?/g;
  const result = inputString.replace(regex, '');
  return result;
  // const filter = predefinedSuggestions.find((item) => item.shortName === result?.trim()?.replace(/`/g, ''));
  // return filter && filter?.aggCode ? filter?.aggCode : null
};

function getAggCodeFromShortName(shortName, options) {
  // const shortNames = shortName.split(/[+,]/).map((name) => name.trim());
  // const suggestion = predefinedSuggestions.find((item) => shortNames.includes(item.shortName));
  const suggestion = options.find((item) => item.shortName === shortName);
  return suggestion ? suggestion.aggCode : null;
};

function getFormula(queryWithAggCode, options) {
  const lines = queryWithAggCode?.split(/\n/);
  const formula = [];
  let currentOperator = null;

  for (let i = 0; i < lines?.length; i++) {
    const line = lines[i].trim();

    if (line === "") {
      continue;
    }

    const operators = line?.match(/AND|OR/);
    if (operators && operators.length > 0) {
      currentOperator = operators?.pop();
    }

    const filters = line?.split(/\b(?:AND|OR)\b/)?.map((item) => item.trim());

    const metricsCriteria = filters?.map((filter) => {
      const condition = filter?.match(/[<>=!]+/);
      const conditionEnum = condition ? getConditionEnum(condition[0]) : null;

      // Split the filter into code and value based on the condition
      const [code, value] = filter?.split(/[<>=!]+/)?.map(item => item.trim()) || [null, null];

      const shortNameMatch = code?.match(/`([^`]+)`/);
      const shortName = shortNameMatch ? shortNameMatch[1] : null;
      const aggCode = getAggCodeFromShortName(shortName || code.trim(), options);

      let updatedFilter = code;
      const shortNames = code.match(/`([^`]+)`/g);

      if (shortNames) {
        shortNames?.forEach((shortName) => {
          const aggCode = getAggCodeFromShortName(shortName?.replace(/`/g, ''), options);
          if (aggCode) {
            updatedFilter = updatedFilter?.replace(shortName, `\`${aggCode}\``);
          }
        });
      }

      return {
        code: `${removeOperatorsAndNumbers(updatedFilter)?.trim()}`,
        condition: conditionEnum,
        value,
      };
    });

    const currentFormula = {
      andor: currentOperator ?? "AND",
      metricsCriteria,
    };

    formula.push(currentFormula);
  }

  return formula.map(item => ({
    ...item,
    metricsCriteria: item.metricsCriteria.filter(criteria => (
      criteria.code !== "" && criteria.condition !== null && criteria.value !== null
    ))
  }))
}

// function checkIfWordBeforeCursorIsSector(input, cursorPosition) {
//   // Split the input string into words
//   const words = input.split(/\s+/);

//   // Get the word before the cursor position
//   let wordBeforeCursor = '';
//   for (let i = 0; i < words.length; i++) {
//     const word = words[i];
//     const wordEndIndex = input.indexOf(word) + word.length;
//     if (wordEndIndex >= cursorPosition) {
//       break;
//     }
//     wordBeforeCursor = word;
//   }

//   // Check if the word before the cursor is "Sector ="
//   if (wordBeforeCursor === "Sector" || wordBeforeCursor === "\nSector") {
//     return true;
//   } else {
//     return false;
//   }
// }

// function checkIfWordBeforeCursorIsSector(input, cursorPosition) {
//   const textBeforeCursor = input.substring(0, cursorPosition);

//   // Split the text before the cursor into lines
//   const lines = textBeforeCursor.split("\n");

//   // Get the last line
//   const lastLine = lines[lines.length - 1];

//   // Check if the last line ends with "Sector ="
//   return lastLine.endsWith("Sector =");
// }

function checkIfCursorAfterSector(input, cursorPosition) {
  const prefix = "Sector =";
  const prefixLength = prefix.length;

  // Extract the portion of the input string before the cursor position
  const textBeforeCursor = input.substring(0, cursorPosition);

  // Check if the text before the cursor ends with "Sector =" (with optional spaces)
  return textBeforeCursor.trimRight().endsWith(prefix);
}

function getLastChar(text) {
  var patt = /([=<>]=?\n)/gi;
  var parts = text.split(patt);
  if (parts.length)
    return parts[parts.length - 1];
  return '';
}

function isSector(text) {
  var patt = /\sand\s|\sor\s|[^a-z0-9 ]|\n/gi;
  var parts = text.split(patt)?.filter(item => item.trim() !== '');
  if (parts?.length < 2) { return false; }
  const [lastElement, secondLastElement] = parts?.slice(-2);
  const isLastElementSector = lastElement?.toLowerCase()?.trim() === 'sector';
  const isSecondLastElementSector = secondLastElement?.toLowerCase()?.trim() === 'sector';
  return isLastElementSector || isSecondLastElementSector;
}

function isIndustry(text) {
  var patt = /\sand\s|\sor\s|[^a-z0-9 ]|\n/gi;
  var parts = text.split(patt)?.filter(item => item.trim() !== '');
  if (parts.length < 2) { return false; }
  const [lastElement, secondLastElement] = parts.slice(-2);
  const isLastElementSector = lastElement?.toLowerCase()?.trim() === 'industry';
  const isSecondLastElementSector = secondLastElement?.toLowerCase()?.trim() === 'industry';
  return isLastElementSector || isSecondLastElementSector;
}

// function getFormula(queryWithAggCode, options) {
//   const lines = queryWithAggCode?.split(/\n/);
//   // const lines = _query?.split(/\n/);
//   const formula = [];
//   let currentOperator = null;

//   for (let i = 0; i < lines?.length; i++) {
//     const line = lines[i].trim();

//     if (line === "") {
//       continue;
//     }

//     const operators = line?.match(/AND|OR/);
//     if (operators && operators.length > 0) {
//       currentOperator = operators?.pop();
//     }

//     const filters = line?.split(/\b(?:AND|OR)\b/)?.map((item) => item.trim());

//     const metricsCriteria = filters?.map((filter) => {
//       const condition = filter?.match(/[<>=]+/);
//       const conditionEnum = condition ? getConditionEnum(condition[0]) : null;
//       const valueMatch = filter?.match(/[\d.]+$/);
//       const value = valueMatch ? parseFloat(valueMatch[0]) : null;
//       const shortNameMatch = filter?.match(/`([^`]+)`/);
//       const shortName = shortNameMatch ? shortNameMatch[1] : null;
//       const aggCode = getAggCodeFromShortName(shortName || filter.trim(), options);
//       const regex = /(<=|>=|<|>)(\d+(\.\d+)?)/g;

//       let updatedFilter = filter;
//       const shortNames = filter.match(/`([^`]+)`/g);

//       if (shortNames) {
//         shortNames?.forEach((shortName) => {
//           const aggCode = getAggCodeFromShortName(shortName?.replace(/`/g, ''), options);
//           if (aggCode) {
//             updatedFilter = updatedFilter?.replace(shortName, `\`${aggCode}\``);
//           }
//         });
//       }

//       if (value === null || isNaN(value)) {
//         console.log(`Line ${i + 1} contains an invalid numeric value.`);
//       }

//       return {
//         code: `${removeOperatorsAndNumbers(updatedFilter)?.trim()}`,
//         condition: conditionEnum,
//         value,
//       };
//     });

//     const currentFormula = {
//       andor: currentOperator ?? "AND",
//       metricsCriteria,
//     };

//     formula.push(currentFormula);
//   }

//   return formula.map(item => ({
//     ...item,
//     metricsCriteria: item.metricsCriteria.filter(criteria => (
//       criteria.code !== "" && criteria.condition !== null && criteria.value !== null
//     ))
//   }))
// };

function validateLines(text, options) {
  if (!text || !text.trim()) return [];
  const lines = text.split(/\n/);
  return lines.map((raw, lineIndex) => {
    const line = raw.trim();
    if (line === '') return { lineIndex, status: 'empty' };
    if (/^(AND|OR)$/i.test(line)) return { lineIndex, status: 'connector' };

    // Strip leading AND/OR
    const stripped = line.replace(/^(AND|OR)\s*/i, '').trim();
    if (stripped === '') return { lineIndex, status: 'connector' };

    // Sector/Industry lines
    if (/^Sector\s*=\s*.+/i.test(stripped)) return { lineIndex, status: 'valid' };
    if (/^Industry\s*=\s*.+/i.test(stripped)) return { lineIndex, status: 'valid' };

    // Try to extract condition
    const condMatch = stripped.match(/[<>=!]+/);
    if (!condMatch) return { lineIndex, status: 'error', message: 'Missing condition (use <, >, =, etc.)' };

    const condEnum = getConditionEnum(condMatch[0]);
    if (!condEnum) return { lineIndex, status: 'error', message: `Unknown operator "${condMatch[0]}"` };

    const [metricPart, valuePart] = stripped.split(/[<>=!]+/).map(s => s.trim());
    if (!metricPart) return { lineIndex, status: 'error', message: 'Missing metric name' };
    if (!valuePart || (isNaN(valuePart) && valuePart === ''))
      return { lineIndex, status: 'error', message: 'Missing numeric value' };

    // Check metric against options
    const metricClean = metricPart.replace(/`/g, '');
    const found = options?.find(o =>
      o.shortName.toLowerCase() === metricClean.toLowerCase() ||
      o.aggCode.toLowerCase() === metricClean.toLowerCase()
    );
    if (!found) return { lineIndex, status: 'error', message: `Unrecognized metric "${metricClean}"` };

    return { lineIndex, status: 'valid' };
  });
}

exports.handleKeyDown = handleKeyDown;
exports.handleBlur = handleBlur;
exports.hideMenu = hideMenu;
exports.handleUnmount = handleUnmount;

exports.insertWord = insertWord;
exports.getLastWordBeforeCursor = getLastWordBeforeCursor;
exports.getTillCursor = getTillCursor;

exports.getFormula = getFormula;

exports.checkIfWordIsSector = checkIfCursorAfterSector;
exports.getLastChar = getLastChar;
exports.isSector = isSector;
exports.isIndustry = isIndustry;
exports.validateLines = validateLines;
